import React from 'react';

import { Card, Box, Button, Text, TextButton } from 'wix-style-react';
import { ConfirmSmall } from 'wix-ui-icons-common';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { datahooks } from '../../../../constants';
import * as css from './IntegrationSection.scss';

export interface IngegrationSectionProps extends InjectedTranslateProps {
  name: string;
  onViewMoreClicked?(): void;
  children: JSX.Element[];
}

const IntegrationSectionComponent: React.FC<IngegrationSectionProps> = (
  props,
) => {
  return (
    <Box marginBottom="24px" marginTop="18px" direction="vertical">
      <Card>
        <Card.Header
          dataHook={datahooks.integrationSectionTitle(props.name)}
          title={props.t(`integrations.${props.name}.title`)}
          suffix={
            <Box paddingRight="5px">
              <TextButton
                size="medium"
                dataHook={datahooks.integrationSectionViewMore(props.name)}
                onClick={props.onViewMoreClicked}
              >
                {props.t('integrations.section.viewMore')}
              </TextButton>
            </Box>
          }
        />
        {props.children.map((row, ind) => (
          <div key={`row-${ind}`}>
            <Card.Divider />
            {row}
          </div>
        ))}
      </Card>
    </Box>
  );
};

export interface IntegrationRowProps extends InjectedTranslateProps {
  name: string;
  imageSrc?: string;
  title: string;
  isConnected: boolean;
  subtitle: string;
  actionOnClick?(): void;
  svg?: JSX.Element;
}

export const IntegrationRowComponent: React.FC<IntegrationRowProps> = (
  props,
) => {
  return (
    <Box
      verticalAlign="middle"
      align="space-between"
      padding="22px 30px 26px 28px"
    >
      <Box verticalAlign="middle">
        <Box height="35px" width="35px" marginRight="17px">
          {props.svg || (
            <img alt="" height="35" width="35" src={props.imageSrc} />
          )}
        </Box>
        <Box direction="vertical">
          <Text
            weight="bold"
            dataHook={datahooks.integrationRowTitle(props.name)}
          >
            {props.title}
          </Text>
          <Text
            size="tiny"
            dataHook={datahooks.integrationRowSubtitle(props.name)}
          >
            {props.subtitle}
          </Text>
        </Box>
      </Box>
      {props.isConnected ? (
        <Box paddingRight="11x" color="#3899ec" verticalAlign="middle">
          <Box marginRight="6px">
            <ConfirmSmall />
          </Box>
          <Text
            size="small"
            className={css.connectedText}
            dataHook={datahooks.integrationRowConnected(props.name)}
          >
            {props.t('integrations.row.connected')}
          </Text>
        </Box>
      ) : (
        <Button
          dataHook={datahooks.integrationRowConnectButtton(props.name)}
          priority="secondary"
          size="small"
          onClick={props.actionOnClick}
        >
          {props.t('integrations.row.connect')}
        </Button>
      )}
    </Box>
  );
};

export const IntegrationSection = translate()(IntegrationSectionComponent);
export const IntegrationRow = translate()(IntegrationRowComponent);
